export interface PopularDestination {
  countryId: string;
  citySlug: string;
  label: string;
}

export const POPULAR_DESTINATIONS: PopularDestination[] = [
  { countryId: 'FR', citySlug: 'paris', label: 'Paris' },
  { countryId: 'IT', citySlug: 'rome', label: 'Rome' },
  { countryId: 'GB', citySlug: 'london', label: 'London' },
  { countryId: 'ES', citySlug: 'barcelona', label: 'Barcelona' },
  { countryId: 'NL', citySlug: 'amsterdam', label: 'Amsterdam' },
];
